<template>
  <zm-form class="phone-number__search" :disabled="loading" :class="{
    'phone-number__search--error': areaCodeErrorMessage
  }">
    <zm-form-item class="phone-number__search--country">
      <zm-select
        data-testid="checkout-select-188"
        size="large"
        v-model="localNumberState.searchForm.countryIsoCode"
        class="phone-number__search--country-code"
        label="Call from"
      >
        <zm-option
          v-for="item in supportRegionList"
          data-testid="checkout-option-189"
          :key="item.region"
          :value="item.region"
          :label="item.label"
          :disabled="item.disabled"
        />
      </zm-select>
    </zm-form-item>
    <zm-form-item :error="areaCodeErrorMessage">
      <zm-input
        data-testid="checkout-input-190"
        :type="!$context.is.desktop ? 'search' : 'text'"
        size="large"
        :maxlength="3"
        :placeholder="$t('billing.pbx.search_area_code')"
        v-model="localNumberState.searchForm.areaCode"
        class="phone-number__search--area-code"
        @keyup.enter.native="search"
        @input="changeAreaCode"
      >
        <i slot="prefix" class="zm-input__icon zm-icon-search"></i>
      </zm-input>
    </zm-form-item>
    <zm-button
      data-testid="checkout-button-191"
      type="link"
      class="phone-number__search--btn"
      :disabled="searchDisabled"
      @click="search"
      v-if="$context.is.desktop || $context.is.tablet"
    >
      {{ $t('billing.common.search') }}
    </zm-button>
  </zm-form>
</template>

<script>
import { localNumberCountryList } from '@/plans/ZOOM_PHONE/helper/constants';
import { checkAreaCodeLength } from '@/plans/ZOOM_PHONE/helper/validate';
import phoneNumberApiMixin from '@/plans/ZOOM_PHONE/mixin/phone-number-api';
import computedMixin from '@/plans/ZOOM_PHONE/mixin/computed';
import { getDefaultLocalSearchForm, localNumberStore } from '../store';
import { isEmptyVal } from '@/utils';
import _ from 'lodash';
import phoneNumberPropsMixin from '@/plans/ZOOM_PHONE/mixin/phone-number-props';
import { getCurrentTrackingPlanName } from '@/plans/ZOOM_PHONE/helper/utils';

export default {
  name: 'LocalSearch',
  mixins: [phoneNumberApiMixin, computedMixin, phoneNumberPropsMixin],
  data() {
    return {
      supportRegionList: localNumberCountryList,
      areaCodeErrorMessage: '',
      localNumberState: localNumberStore.state,
      lastSearchForm: getDefaultLocalSearchForm(),
    };
  },
  computed: {
    trackingPlanName() {
      return getCurrentTrackingPlanName();
    },
    searchDisabled() {
      return isEmptyVal(this.localNumberState?.searchForm?.areaCode) || !isEmptyVal(this.areaCodeErrorMessage);
    },
  },
  methods: {
    changeAreaCode(search) {
      this.areaCodeErrorMessage = checkAreaCodeLength(search);
    },
    async search() {
      if (this.searchDisabled) return;

      const existUnReadNumber = this.checkExistUnreadPhoneNumbers();
      const searchForm = this.localNumberState.searchForm;
      const lastSearchForm = this.lastSearchForm;

      // exist unread phoneNumbers with current call api result
      if (_.isBoolean(existUnReadNumber) && existUnReadNumber && _.isEqual(searchForm, lastSearchForm)) {
        return this.gotoNextPage();
      }

      const list = await this.searchLocalNumbers(searchForm);
      this.localNumberState.phoneNumberList = list;
      this.localNumberState.searchTimes++;
      this.lastSearchForm = _.cloneDeep(searchForm);
      this.$tracking.buyInteraction(`${this.trackingPlanName} numbers`, `${this.callingPlanName} - pick your numbers - local - search`);
    },
    toggleLoading(value = false) {
      this.loading = value;
      this.localNumberState.loading = value;
      this.$emit('toggleLoading', value);
    },
    resetForm() {
      if (this.areaCodeErrorMessage) {
        this.areaCodeErrorMessage = '';
        this.localNumberState.searchForm = getDefaultLocalSearchForm();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style/number-search.scss";
</style>
